<template>
	<v-row justify="center">
		<v-col cols="10" lg="4" md="5" sm="7">
			<v-card class="mx-auto mt-3">
				<v-card-title v-if="provider" class="primary--text" v-translate>Register Provider</v-card-title>
				<v-card-title v-else class="primary--text" v-translate>Register</v-card-title>
				<v-card-text class="pb-0 px-8">
					<v-form v-if="!success" ref="form" v-model="valid" lazy-validation>
						<v-alert v-model="error" color="red lighten-2" class="text-caption" icon="warning">
							{{errorMessage}}
						</v-alert>
						<v-text-field v-model="email" label="Email" :rules="emailRules" filled placeholder=" " validate-on-blur />
						<v-text-field
							v-model="name"
							:label="$gettext('Name')"
							:rules="nameRules"
							filled
							validate-on-blur
							placeholder=" "
						/>
						<v-text-field
							v-if="provider"
							v-model="provider_name"
							:label="$gettext('Provider Name')"
							:rules="nameRules"
							filled
							validate-on-blur
							placeholder=" "
						/>
						<v-text-field
							v-model="password"
							type="password"
							:label="$gettext('Password')"
							:rules="passwordRules"
							filled
							validate-on-blur
							placeholder=" "
						/>
						<v-text-field
							v-model="again"
							type="password"
							:label="$gettext('Repeat Password')"
							:rules="againRules"
							filled
							validate-on-blur
							placeholder=" "
						/>
						<v-checkbox
							v-model="termsAndConditions"
							class="mt-0 pt-0"
							color="primary"
							:rules="termsAndConditionsRules"
							dense
						>
							<template slot="label">
								<span v-translate class="mr-1">Accept the</span>
								<a v-translate class="primary--text" @click.stop.prevent="getTermsAndConditions">Terms and Conditions</a>
							</template>
						</v-checkbox>
						<v-checkbox
							v-model="privacyPolicy"
							class="mt-0 pt-0"
							color="primary"
							:rules="privacyPolicyRules"
							dense
						>
							<template slot="label">
								<span class="mr-1"><translate translate-context="policy">Accept the</translate></span>
								<a v-translate class="primary--text" @click.stop.prevent="getPrivacyPolicy">Privacy Policy</a>
							</template>
						</v-checkbox>
					</v-form>
					<v-alert v-else color="alert" type="success" class="text-caption">
						<translate>Registration Successful! You can now log in into your account.</translate>
					</v-alert>
				</v-card-text>
				<v-divider class="mt-2"></v-divider>
				<v-card-actions class="pa-3">
					<v-spacer></v-spacer>
					<v-btn v-if="!success" depressed color="primary" @click="register" :loading="loading" key="register">
						<translate>Register</translate>
					</v-btn>
					<v-btn v-else depressed color="primary" :to="{name: 'login'}" key="login">
						<translate>Enter</translate>
					</v-btn>
				</v-card-actions>
			</v-card>
		</v-col>
		<v-dialog v-model="showTermsAndConditions" width="70%" scrollable>
			<v-card :loading="loadingTermsAndConditions">
				<v-card-title class="title primary--text mb-2 secondary">
					<v-icon class="mr-3" color="primary">mdi-information</v-icon>
					<span v-translate class="mr-1">Terms and Conditions</span>
				</v-card-title>
				<v-card-text class="pt-4">
					<div v-html="termsAndConditionsText"/>
				</v-card-text>
				<v-divider></v-divider>
				<v-card-actions>
					<v-spacer></v-spacer>
					<v-btn color="primary darken-1" text @click="showTermsAndConditions = false">
						<translate>Close</translate>
					</v-btn>
				</v-card-actions>
			</v-card>
		</v-dialog>
		<v-dialog v-model="showPrivacyPolicy" width="70%" scrollable>
			<v-card :loading="loadingPrivacyPolicy">
				<v-card-title class="title primary--text mb-2 secondary">
					<v-icon class="mr-3" color="primary">mdi-information</v-icon>
					<span v-translate class="mr-1">Privacy Policy</span>
				</v-card-title>
				<v-card-text class="pt-4">
					<div v-html="privacyPolicyText"/>
				</v-card-text>
				<v-divider></v-divider>
				<v-card-actions>
					<v-spacer></v-spacer>
					<v-btn color="primary darken-1" text @click="showPrivacyPolicy = false">
						<translate>Close</translate>
					</v-btn>
				</v-card-actions>
			</v-card>
		</v-dialog>
	</v-row>
</template>

<script>
import axios from "axios";
import Vue from 'vue';

export default {
	name: "register-form",
	props: {
		provider: {
			default: false
		}
	},
	data: () => ({
		valid: true,
		email: "",
		name: "",
		provider_name: "",
		password: "",
		again: "",
		health_professional: false,
		specialty: "",
		license_number: "",
		space_name: null,
		company_name: "",
		company_nif: "",
		loading: false,
		error: false,
		termsAndConditions: false,
		showTermsAndConditions: false,
		termsAndConditionsText: "",
		loadingTermsAndConditions: true,
		privacyPolicy: false,
		showPrivacyPolicy: false,
		privacyPolicyText: "",
		loadingPrivacyPolicy: true,
		errorMessage: "",
		success: false
	}),
	methods: {
		validate() {
			return this.$refs.form.validate();
		},
		register() {
			if (this.validate()) {
				this.loading = true;
				this.error = false;
				const formData = new FormData();
				formData.append("email", this.email);
				formData.append("name", this.name);
				formData.append("password", this.password);
				formData.append("again", this.again);
				formData.append("language", Vue.config.language);
				if(this.provider) {
					formData.append("provider", true);
					formData.append("provider_name", this.provider_name);
				}
				let referral = this.$route.query.referral;
				if(referral) formData.append("referral_space_id", referral);

				this.$store
					.dispatch("REGISTER", formData)
					.then(response => {
						console.log(response);
						if (response.result === "registered") {
							this.loading = false;
							// ADD LOGIN-PROVIDER ROUTE
							// this.$router.push({
							// 	name: "login",
							// 	params: { afterRegistration: true }
							// });
							this.success = true;
						} else if (response.result === "error") {
							this.loading = false;
							this.error = true;
							this.errorMessage = response.error[Object.keys(response.error)[0]][0];
						}
					})
					.catch(error => {
						console.log(error);
						this.loading = false;
						this.error = true;
						this.errorMessage = "Erro.";
					});
			}
		},
		getTermsAndConditions() {
			this.showTermsAndConditions = true;
			axios
				.get("/terms-conditions", {params: {lang: Vue.config.language}})
				.then(response => {
					if (response.status === 200) {
						this.termsAndConditionsText = response.data.text;
						this.loadingTermsAndConditions = false;
					}
				})
				.catch(error => {
					console.log(error)
				});
		},
		getPrivacyPolicy() {
			this.showPrivacyPolicy = true;
			axios
				.get("/privacy-policy", {params: {lang: Vue.config.language}})
				.then(response => {
					if (response.status === 200) {
						this.privacyPolicyText = response.data.text;
						this.loadingPrivacyPolicy = false;
					}
				})
				.catch(error => {
					console.log(error)
				});
		}
	},
	computed: {
		vatNumber() {
			return this.$pgettext("company", "VAT Number");
		},
		passwordRules() {
			return [
				v => !!v || this.$gettext("Password is required"),
				v =>
					(v && v.length >= 8) ||
					this.$gettext("Password must have at least 8 characters")
			];
		},
		emailRules() {
			return [
				v => !!v || this.$gettext("E-mail is required"),
				v => /.+@.+\..+/.test(v) || this.$gettext("E-mail must be valid")
			];
		},
		nameRules() {
			return [v => !!v || this.$gettext("Name is required")];
		},
		termsAndConditionsRules() {
			return [v => !!v || this.$gettext("It's required to accept Terms and Conditions")];
		},
		privacyPolicyRules() {
			return [v => !!v || this.$gettext("It's required to accept Privacy Policy")];
		},
		companyNameRules() {
			return [v => !!v || this.$gettext("Company Name is required")];
		},
		companyNIFRules() {
			return [v => !!v || this.$gettext("VAT Number is required")];
		},
		againRules() {
			return [
				v => (v && v == this.password) || this.$gettext("Passwords must match")
			];
		}
	}
};
</script>

<style scoped>
>>> .v-input--selection-controls .v-input__slot > .v-label {
		font-size: 13px;
}
</style>